/**
 * Undoes the HTML escaping a variables formatter applies, for a value that goes
 * into an `href`. The return formatter escapes every value (`&` → `&amp;`) so it
 * can be injected as HTML; React escapes the attribute again, so a link like
 * `?shop=P1&orderId=123&bbt=…` reached customers as `?shop=P1&amp;amp;orderId=…`:
 * the browser kept `shop` only, the order and its token were lost.
 */
export function decodeHref(href: string | undefined): string | undefined {
  return href
    ?.replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, "&");
}
